import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

/**
 * This component handles displaying a colon seperated name value pair.
 *
 * Since this is a very general component, styles should not be added here.
 * Instead, they should be added to components that wrap this one.
 */
export default function ItemField({ name, value, className }) {
  if (!value) {
    return null;
  }

  const classNames = cn('cp-item-field', className);

  return (
    <div className={classNames}>
      <FormattedMessage
        id="labeled_value"
        values={{
          name: <span className="field-name">{name}</span>,
          value: <span className="field-value">{value}</span>
        }} />
    </div>
  );
}


ItemField.propTypes = {
  name: childrenShape,
  value: childrenShape,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/ItemField/ItemField.jsx